import { partition } from 'lodash';

export const partitionFilesAndFolders = (
  items: Array<{ type: 'FOLDER' } | any>
) => partition(items, (item) => item?.type === 'FOLDER');
